module.exports = __webpack_public_path__ + "static/media/tv.8852e4e8.svg";